module.exports = __webpack_public_path__ + "static/media/Motivo3.1d665a0c.png";